import React from "react";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const SHORTCUTS = [
  {
    label: "Today",
    getValue: () => {
      const d = dayjs();
      return [d, d];
    },
  },
  {
    label: "Yesterday",
    getValue: () => {
      const d = dayjs().subtract(1, "day");
      return [d, d];
    },
  },
  { label: "This Week", getValue: () => [dayjs().startOf("week"), dayjs().endOf("week")] },
  {
    label: "Last Week",
    getValue: () => {
      const s = dayjs().subtract(1, "week");
      return [s.startOf("week"), s.endOf("week")];
    },
  },
  { label: "This Month", getValue: () => [dayjs().startOf("month"), dayjs().endOf("month")] },
  {
    label: "Last Month",
    getValue: () => {
      const s = dayjs().subtract(1, "month");
      return [s.startOf("month"), s.endOf("month")];
    },
  },
  { label: "This Year", getValue: () => [dayjs().startOf("year"), dayjs().endOf("year")] },
  {
    label: "Last Year",
    getValue: () => {
      const s = dayjs().subtract(1, "year");
      return [s.startOf("year"), s.endOf("year")];
    },
  },
];

export default function DateRangeShortcutPicker({ startDate, endDate, onChange }) {
  const value = [startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null];

  const handleChange = (newValue) => {
    onChange(
      newValue[0]?.isValid() ? newValue[0].format("YYYY-MM-DD") : "",
      newValue[1]?.isValid() ? newValue[1].format("YYYY-MM-DD") : "",
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        slots={{
          field: SingleInputDateRangeField,
          openPickerIcon: () => (
            <i className="fa-light fa-calendar-days" style={{ fontSize: "20px" }} />
          ),
        }}
        value={value}
        onChange={handleChange}
        format="DD/MM/YYYY"
        slotProps={{
          shortcuts: { items: SHORTCUTS },
          actionBar: { actions: [] },
          textField: {
            size: "small",
            sx: {
              width: 240,
              "& .MuiOutlinedInput-root": {
                height: 40,
                fontFamily: "Poppins, sans-serif",
                fontSize: 13,
                backgroundColor: "#fff",
                boxShadow: "1px 1px 4px 1px #29292921",
                borderRadius: "6px",
              },
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
              "& .MuiInputBase-input": {
                fontFamily: "Poppins, sans-serif",
                fontSize: 13,
                color: "#686868",
                fontWeight: 300,
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
